import logo from './logo.svg';
import './App.css';
import Home from './Home';
import {BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import Description from './Description';
import Navbar from './Navbar';
import { Contentarea } from './Contentarea';

function App() {
  return (
    <>
    <Router>
    <Navbar/>
    <Contentarea/>
    </Router>
    
    </>

  );
}

export default App;
